module.exports = __webpack_public_path__ + "img/sub-nav-links-honda.7f4fcc72.png";